export const environment = {
  production: true,
  BASE_DOMAIN:'https://ftl-uat.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://ftl-uat.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://ftl-uat.apollosupplychain.com/',
  WebsocketUrl: 'wss://ftl-uat.apollosupplychain.com/websocket-service/ws/notifications'

  // BASE_DOMAIN:'https://dev.goalfa.in/',
  // New_BASE_DOMAIN:'https://alfa.goalfa.in/',
  // COOKIE_DOMAIN: 'localhost',
  // ORDER_URL: 'https://alfa.goalfa.in/',
  // WebsocketUrl: 'wss://alfa.goalfa.in/websocket-service/ws/notifications'
};
